import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router';
import RouteLogger from '../../helpers/RouteLogger';

import TerritoriesList from '../../views/Territories/List';
import TerritoriesFilters from '../../views/Territories/Filters';
import TerritoriesFilterDetails from '../../views/Territories/FilterDetails';

const TerritoriesRoutes=(props)=>{
	return <RouteLogger>
			<Switch>
				<Route path="/territories/filters/:id" component={(TerritoriesFilterDetails)}></Route>
				<Route path="/territories/filters" component={(TerritoriesFilters)}></Route>
				<Route path="/territories/:continent?" component={(TerritoriesList)}></Route>
			</Switch>
		</RouteLogger>
	}
export default TerritoriesRoutes;
